const functions = {
    checkTokenExpiry : (tokenExpiresIn) => {
      return tokenExpiresIn < +Date.now();
    },
  
    cleanTokens: () => {
      localStorage.removeItem("TOKEN");
      localStorage.removeItem("TOKEN_EXPIRES_IN");
      localStorage.removeItem("TOKEN_REFRESH");
    },
  
    checkDataLocalStorage : () => {
      return (localStorage.TOKEN && localStorage.TOKEN_EXPIRES_IN && localStorage.TOKEN_REFRESH);
    },
  
    createTimestamExpiresIn : (expiresIn) => {
      let expireDate = new Date(Date.now() + (expiresIn * 1000));
  
      return +expireDate;
    },

    CategoryResponsibleEmails: function(selectedContactCategory) {
      switch (selectedContactCategory) {
        case "GENERAL":
          return ["prodeco@prodeco.cz"];

        default:
          return ["prodeco@prodeco.cz"];
      }
    }
  }
  
  export default functions;